import { useTranslation } from 'react-i18next';

export default function ContactInfo() {
  const { t } = useTranslation();

  const infoItems = [
    {
      icon: 'ri-map-pin-2-fill',
      label: t('contact_info_address_label'),
      content: t('contact_info_address'),
      isMultiline: true,
      extra: (
        <a
          href="https://www.google.com/maps/dir/?api=1&destination=3202+Lealand+Pl+Ln,+Lawrenceville,+GA+30044"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center gap-1.5 mt-2 text-sky-400 hover:text-sky-300 text-xs font-semibold transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-navigation-fill text-xs"></i>
          {t('contact_info_directions')}
        </a>
      ),
    },
    {
      icon: 'ri-phone-fill',
      label: t('contact_info_phone_label'),
      content: null,
      isMultiline: false,
      extra: (
        <a
          href="tel:+15615122820"
          className="text-white font-semibold text-lg hover:text-sky-300 transition-colors cursor-pointer"
        >
          +1 (561) 512-2820
        </a>
      ),
    },
    {
      icon: 'ri-mail-fill',
      label: t('contact_info_email_label'),
      content: null,
      isMultiline: false,
      extra: (
        <a
          href="mailto:info@orpminvestment.com"
          className="text-sky-400 hover:text-sky-300 text-sm font-medium transition-colors cursor-pointer"
        >
          info@orpminvestment.com
        </a>
      ),
    },
    {
      icon: 'ri-time-fill',
      label: t('contact_info_hours_label'),
      content: t('contact_info_hours'),
      isMultiline: true,
      extra: null,
    },
  ];

  const whyItems = [
    {
      icon: 'ri-gift-2-fill',
      titleKey: 'contact_why1_title',
      textKey: 'contact_why1_text',
    },
    {
      icon: 'ri-flashlight-fill',
      titleKey: 'contact_why2_title',
      textKey: 'contact_why2_text',
    },
    {
      icon: 'ri-award-fill',
      titleKey: 'contact_why3_title',
      textKey: 'contact_why3_text',
    },
  ];

  return (
    <div className="flex flex-col gap-6 h-full">
      {/* Info card */}
      <div className="bg-[#0F2340] rounded-2xl p-8">
        <h3 className="text-white font-bold text-lg mb-6">{t('contact_info_title')}</h3>
        <div className="space-y-6">
          {infoItems.map((item) => (
            <div key={item.label} className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-sky-500/20 border border-sky-400/20 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-sky-400 text-base`}></i>
              </div>
              <div>
                <p className="text-slate-400 text-xs font-semibold uppercase tracking-wider mb-1">
                  {item.label}
                </p>
                {item.isMultiline && item.content ? (
                  <p className="text-slate-200 text-sm leading-relaxed" style={{ whiteSpace: 'pre-line' }}>
                    {item.content}
                  </p>
                ) : null}
                {item.extra}
              </div>
            </div>
          ))}
        </div>

        {/* Response time note */}
        <div className="mt-6 pt-5 border-t border-white/10 flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-emerald-400 shrink-0"></div>
          <p className="text-slate-300 text-xs">{t('contact_info_response')}</p>
        </div>
      </div>

      {/* Why contact us */}
      <div className="bg-[#F7F9FC] rounded-2xl p-7">
        <h3 className="text-slate-800 font-bold text-base mb-5">{t('contact_why_title')}</h3>
        <div className="space-y-4">
          {whyItems.map((item) => (
            <div key={item.titleKey} className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-lg bg-sky-100 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-sky-600 text-sm`}></i>
              </div>
              <div>
                <p className="text-slate-800 font-semibold text-sm">{t(item.titleKey)}</p>
                <p className="text-slate-500 text-xs mt-0.5 leading-relaxed">{t(item.textKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Google Map */}
      <div className="rounded-2xl overflow-hidden" style={{ height: '220px' }}>
        <iframe
          title="ORPM Investment LLC Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3310.0!2d-84.0!3d33.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a3e6b2c00001%3A0x1!2s3202+Lealand+Pl+Ln%2C+Lawrenceville%2C+GA+30044!5e0!3m2!1sen!2sus!4v1710000000000"
          width="100%"
          height="220"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}
